<template>
  <div>
    <v-btn
      v-if="showAnalyticsBetaButton"
      class="beta-version-fab white--text"
      color="blueSpace"
      elevation="0"
      :loading="betaRedirecting"
      :disabled="betaRedirecting"
      @click="openAnalyticsBeta"
    >
      <v-icon>mdi-flash</v-icon>
      <span class="beta-version-fab__label">Experimente a versão beta</span>
      <span class="beta-version-fab__badge">Novo</span>
    </v-btn>
    <DialogResponse
      v-if="modalResponse.showModal"
      :ModalResponse="modalResponse"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogResponse from '@/components/Dashboard/DialogResponse/DialogResponse.vue'
import { guestAccessFromUserId } from '@/utils/guestAccess'
import { analyticsV5Base, openAnalyticsV5Beta } from '@/services'

export default {
  name: 'BetaVersionFab',

  components: {
    DialogResponse,
  },

  data: () => ({
    betaRedirecting: false,
    modalResponse: {
      showModal: false,
      message: '',
    },
  }),

  computed: {
    ...mapGetters('auth', ['user']),

    showAnalyticsBetaButton() {
      if (!analyticsV5Base()) return false
      return this.$route.name === 'SingleCampaign' || this.$route.name === 'SitesView'
    },
  },

  mounted() {
    // Volta pelo botão do navegador restaura a página em cache com betaRedirecting ainda true.
    this.onPageShow = () => {
      this.betaRedirecting = false
    }
    window.addEventListener('pageshow', this.onPageShow)
  },

  beforeDestroy() {
    window.removeEventListener('pageshow', this.onPageShow)
  },

  methods: {
    async openAnalyticsBeta() {
      if (this.betaRedirecting) return
      this.betaRedirecting = true
      try {
        const guest = guestAccessFromUserId(this.user?.user_id)
        const guestJwt = guest ? window.localStorage.getItem('analytics_jwt') : null
        if (guest && !guestJwt) {
          throw new Error('Token de veículo ausente')
        }
        await openAnalyticsV5Beta({
          campaignId: parseInt(this.$route.params.campaign_id, 10),
          siteId: this.$route.params.site_id
            ? parseInt(this.$route.params.site_id, 10)
            : null,
          guestJwt,
        })
      } catch (error) {
        console.log(error)
        this.betaRedirecting = false
        this.modalResponse = {
          showModal: true,
          status: 'error',
          title: 'Não foi possível abrir a versão beta',
        }
      }
    },
  },
}
</script>

<style scoped>
.beta-version-fab {
  height: 44px !important;
  padding: 0 8px 0 16px !important;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: none;
  border-radius: 999px !important;
  box-shadow: 0 8px 20px rgba(33, 150, 243, 0.35);
  animation: beta-fab-glow 2.2s ease-out infinite;
}
.beta-version-fab .v-icon {
  font-size: 22px !important;
  margin: 0 8px 0 0 !important;
}
.beta-version-fab__label {
  white-space: nowrap;
}
.beta-version-fab__badge {
  margin-left: 10px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #ffe082;
  color: #0d47a1;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1.4;
  text-transform: uppercase;
  white-space: nowrap;
  animation: beta-badge-glow 2.2s ease-in-out infinite;
}
.beta-version-fab:hover {
  animation-play-state: paused;
  box-shadow: 0 10px 24px rgba(33, 150, 243, 0.5);
}
.beta-version-fab:hover .beta-version-fab__badge {
  animation-play-state: paused;
}
@keyframes beta-fab-glow {
  0% {
    box-shadow: 0 8px 20px rgba(33, 150, 243, 0.35), 0 0 0 0 rgba(66, 165, 245, 0.55);
  }
  70% {
    box-shadow: 0 8px 20px rgba(33, 150, 243, 0.35), 0 0 0 10px rgba(66, 165, 245, 0);
  }
  100% {
    box-shadow: 0 8px 20px rgba(33, 150, 243, 0.35), 0 0 0 0 rgba(66, 165, 245, 0);
  }
}
@keyframes beta-badge-glow {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(255, 224, 130, 0);
  }
  50% {
    box-shadow: 0 0 10px 2px rgba(255, 224, 130, 0.9);
  }
}
@media (prefers-reduced-motion: reduce) {
  .beta-version-fab,
  .beta-version-fab__badge {
    animation: none;
  }
}
</style>
